import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-generic-content-node',
  templateUrl: './generic-content-node.component.html',
  styleUrls: ['./generic-content-node.component.scss']
})
export class GenericContentNodeComponent implements OnInit {

 
  @Input() node: any;
  constructor() {
   }
  ngOnInit(): void {
    
  }

}
